import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { SxProps } from "@mui/material";

interface CustomDateCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  className?: string;
  sx?: SxProps;
  disabled?: boolean;
}

const CustomDateCheckbox = ({
  checked,
  onChange,
  label = "Use relative dates",
  className,
  sx,
  disabled,
}: CustomDateCheckboxProps) => (
  <FormControlLabel
    sx={sx}
    disabled={disabled}
    control={
      <Checkbox
        checked={checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        disabled={disabled}
      />
    }
    label={
      <span className={className}>{label}</span>
    }
  />
);

export default CustomDateCheckbox;
